import React from "react";
import { Container } from "reactstrap";
import Breadcrumb from "../../components/common/Breadcrumb";
import MetaTag from "../../components/common/MetaTagSeo";
import { LoanRequestPage } from "../../constant/SCO_Name";
import { FinancialStatmentMngt } from "../../constant/RouteName";
import useFetch from "../../hooks/useFetch";
import { ServerError } from "../../constant/NotifyMessage";
import Loading from "../../components/helper/Loading";
import { useStore1Selector } from "index";
import { loginUser } from "../../Redux/Slices/userSlice";
import SmallModal from "../../components/common/SmallModal";
import SendToBlackList from "../../sections/Management/debt-collection/SendToBlackList";
import { BsEyeFill } from "react-icons/bs";
import ModalComp from "../../components/common/Modal";
import ErrorPage from "../../components/helper/ErrorPage";
import usePost from "../../hooks/usePost";
import Table from "../../components/common/Table";
import { managementDebtColumns } from "../../constant/Columns";
import { formatDate } from "../../utils/dateFormat"
import ViewLoan from "../../components/views/ViewLoan";
import LoadingAnimation from "../../components/helper/Loading-animation";

const DebtCollectors = () => {
  const userDet = useStore1Selector(loginUser);
  const token = userDet?.token;
  const res_data = [];

  const { execute, pending } = usePost()

  const { data, loading, error, reFetch } = useFetch(
    `${process.env.REACT_APP_BACKEND_URL}/loans/management/debt-collectors?debtCollector=true&debtCollectorPaymentStatus=false&blackListed=false&sort=-createdAt`,
    token
  );
  const [openModal, setOpenModal] = React.useState(false);
  const [status, setStatus] = React.useState();
  const [loanId, setLoanId] = React.useState();
  const [btnName, setBtnName] = React.useState();
  const [viewUserDet, setViewUserDet] = React.useState(false);

  if (loading) return <LoadingAnimation />
  if (error) return <ErrorPage message={ServerError} />;

  const updatePayment = (id) => {
    setOpenModal(true);
    setStatus("verification");
    setLoanId(id);
    setBtnName("Verification");
  };

  const blackList = (id) => {
    const Method = 'PATCH', endPoint = `loans/${id}/debt-collector`;
    const raw = JSON.stringify({
      status: "blacklisted",
      blackListed: true
    });
    execute(endPoint, raw, Method, "Successfully Blacklisted", token)
  };

  if (pending) {
    setTimeout(() => {
      reFetch();
    }, 2000);
  }

  const viewDetails = (id) => {
    setViewUserDet(true);
    setLoanId(id);
  };

  const filterArr = () => {
    data?.forEach((res) => {
      res_data.push({
        ...res,
        firstName: res?.user?.firstName,
        lastName: res?.user?.lastName,
        payment_Date: formatDate(res?.paymentDate),
        debt_start_date: formatDate(res?.updatedAt),
        viewBtn: (
          <button
            className="btn btn__table  color__blue"
            onClick={() => viewDetails(res?._id)}
          >
            <BsEyeFill size={14} /> View
          </button>
        ),
        verifyBtn: (
          <button
            className="btn btn__table color__verify"
            onClick={() => updatePayment(res?._id)}
          >
            Update to paid
          </button>
        ),
        blacklistBtn: (
          <button className="btn btn__table btn-danger" onClick={() => blackList(res?._id)}> {pending ? "Loading..." : "Move to blacklist"}</button>
        ),
      });
    });
  };
  filterArr();

  return (
    <React.Fragment>
      <div className="page-content px-5">
        <Breadcrumb
          default={FinancialStatmentMngt}
          defaultName="Debt collectors"
          title={"debts"}
        />
        <MetaTag title_sco={LoanRequestPage} />

        <Container fluid>
          <div className="page-title-box">
            {loading ? <Loading /> : <Table columns={managementDebtColumns} data={res_data} />}
          </div>
        </Container>
      </div>

      <ModalComp
        ModalTitle=""
        open={viewUserDet}
        onClose={() => setViewUserDet(false)}
        cancel="close"
        Component={
          <ViewLoan onClose={() => setViewUserDet(false)} loan_Id={loanId} />
        }
      />

      <SmallModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        ModalTitle=""
        cancel="close"
        Components={
          <SendToBlackList
            reFetch={reFetch}
            onClose={() => setOpenModal(false)}
            status={status}
            loanId={loanId}
            btnName={btnName}
          />
        }
      />
    </React.Fragment>
  );
};
export default DebtCollectors;
